import React from 'react';
import './style.css'

const UISectionHeading = (props) => {
  const { drawerHeading } = props;
  return (
    <div>
    <h3 className="drawer-heading" >{drawerHeading}</h3>
     <div className="headre-line"></div>
    </div>
  );
}

export default UISectionHeading;
